import { useCallback, useEffect, useState } from 'react';
export function useCarousel() {
    const [activeItem, setActiveItem] = useState(0);
    const [counts, setCounts] = useState(0);
    const indexOfCount = counts - 1;
    const onClickPrevItem = useCallback(() => {
        if (activeItem > 0) {
            setActiveItem(activeItem - 1);
        }
    }, [activeItem]);
    const onClickNextItem = useCallback(() => {
        if (activeItem < indexOfCount) {
            setActiveItem(activeItem + 1);
        }
    }, [activeItem, indexOfCount]);
    useEffect(() => {
        setActiveItem(0);
    }, []);
    return {
        activeItem,
        setActiveItem,
        onClickPrevItem,
        onClickNextItem,
        indexOfCount,
        counts,
        setCounts,
    };
}
